import { render, staticRenderFns } from "./SellerOfferCreate.vue?vue&type=template&id=2a22a72c&scoped=true"
import script from "./SellerOfferCreate.vue?vue&type=script&lang=js"
export * from "./SellerOfferCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22a72c",
  null
  
)

export default component.exports